import React, { useEffect, useState, useMemo } from 'react';
import './services-inventory.scss';
import { observer } from 'mobx-react-lite';
import { InteractiveDataTable } from '../../../shared/interactive-data-table/interactive-data-table';
import { EmptyState } from '../../../shared/empty-state/empty-state';
import { IconType } from '../../../shared/custom-icon/custom-icon';
import { inventoryServicesFiltersConfig } from '../../../shared/filters/filter-config/services-filters';
import { useStores } from '../../../store';
import usePromiseFeedback from '../../../shared/promise-feedback/usePromiseFeedback';
import { createServiceColumns } from './services-column-config';
import { useServicesCrudConfig } from './services-crud-config';
import { InventorySubMenu } from '../../../../utils/enums';
import { Service } from '../../../../dtos/version.dto';
import { convertServiceAndStatusToCustomServiceType } from '../../../../utils/versionUtils';


export const ServicesInventory: React.FC = observer(() => {
    const {fwVersionStore, ruleStore} = useStores();
    const {defaultServicesWithStatus, customServices} = ruleStore;
    const [, promiseContextHolder] = usePromiseFeedback();
    const config = useServicesCrudConfig();
    const [data, setData] = useState<Service[]>([]);
    const serviceColumns = useMemo(() => createServiceColumns(ruleStore.specialServices), [ruleStore.specialServices]);

    useEffect(() => {
        fwVersionStore.setInventoryType(InventorySubMenu.SERVICES);
    } , []);

    useEffect(() => {
        const defaultServices = defaultServicesWithStatus.map(_ => convertServiceAndStatusToCustomServiceType(_));
        setData([...customServices, ...defaultServices]);
    }, [customServices, defaultServicesWithStatus]);

    return (
        <div className="services" data-testid="services">
            <InteractiveDataTable
                filterConfig={inventoryServicesFiltersConfig(fwVersionStore.selectedVersionRules)}
                data={data}
                columnsConfig={serviceColumns}
                crudConfig={config}
                emptyStateComp={<EmptyState
                    iconType={IconType.AllowEmptyState}
                    subTitle="To add new item click"
                    secondarySubTitle=" Add Services"
                />}
                dataHasLoaded={!!fwVersionStore.selectedFwVersion}
                isLoading={fwVersionStore.isLoading || !fwVersionStore.selectedFwVersion}
            />
            <div>{promiseContextHolder}</div>
        </div>
    );
});